import {Pipe, PipeTransform} from '@angular/core';
import {ReportExtensions} from '@spa/api';
import {Language} from '../language';
import {LanguageService} from '../language.service';

@Pipe({
	name: 'formatDecimal'
})
export class FormatDecimalPipe implements PipeTransform {
	constructor(private languageService: LanguageService) {
	}

	transform(value: number, sign?: string, addSpace?: boolean, minimumFractionDigits: number = 2): string {
		let result = ReportExtensions.toDecimalString(
			value,
			4,
			minimumFractionDigits,
			false);

		if (this.languageService.getCurrentLanguage() === Language.Bulgarian) {
			result = result.replace(/,/g, ' ');
			result = result.replace('.', ',');
		}

		if (sign) {
			if (addSpace) {
				return `${sign} ${result}`;
			}

			return `${sign}${result}`;
		}

		return result;
	}
}
